import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAdminTheme } from "@/admin/AdminTheme";
import { ACard, AButton, AdminPageTitle } from "@/admin/ui";
import { StarRating } from "@/components/StarRating";
import { Spinner } from "@/components/common";
import { toast } from "sonner";

export default function AdminReviews() {
  const { c } = useAdminTheme();
  const [reviews, setReviews] = useState(null);

  const load = () => api("/admin/reviews").then(setReviews).catch(() => setReviews([]));
  useEffect(() => { load(); }, []);
  if (!reviews) return <Spinner full />;

  const del = async (id) => {
    if (!window.confirm("Delete this review?")) return;
    try { await api(`/admin/reviews/${id}`, { method: "DELETE" }); toast.success("Review deleted"); load(); } catch (e) { toast.error(e.message); }
  };

  return (
    <div className="fade-up" style={{ maxWidth: 900 }}>
      <AdminPageTitle title="Reviews" subtitle={`${reviews.length} total`} />
      <ACard style={{ padding: 0, overflow: "hidden" }}>
        {reviews.length === 0 ? <p style={{ padding: 24, color: c.mutedText }}>No reviews yet.</p> : reviews.map((r) => (
          <div key={r.id} style={{ display: "flex", gap: 14, padding: "14px 18px", borderBottom: `1px solid ${c.divider}` }}>
            {r.product_image && <img src={r.product_image} alt="" style={{ width: 48, height: 48, borderRadius: 8, objectFit: "cover", flexShrink: 0 }} />}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
                <div style={{ fontWeight: 700, fontSize: 13.5 }} className="clamp-1">{r.product_name}</div>
                <StarRating rating={r.rating} showCount={false} size={13} />
              </div>
              <div style={{ fontSize: 12.5, color: c.mutedText }}>by {r.user_name}</div>
              {r.title && <div style={{ fontWeight: 600, fontSize: 13.5, marginTop: 4 }}>{r.title}</div>}
              {r.body && <p style={{ margin: "4px 0 0", fontSize: 13.5, color: c.onSurfaceSecondary }}>{r.body}</p>}
              {r.photos?.length > 0 && <div style={{ display: "flex", gap: 6, marginTop: 8 }}>{r.photos.map((p, i) => <img key={i} src={p} alt="" style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 6 }} />)}</div>}
            </div>
            <AButton variant="ghost" style={{ padding: 8, color: c.danger, alignSelf: "flex-start" }} data-testid={`review-delete-${r.id}`} onClick={() => del(r.id)}><Trash2 size={15} /></AButton>
          </div>
        ))}
      </ACard>
    </div>
  );
}
